import React from 'react'
import { Popup } from 'react-leaflet'

import './popup.css'

// wrapper for Popup fra react-leaflet for å få lagt på egen styling
const VATPopup = (props) => <Popup {...props} />

VATPopup.defaultProps = {
    className: 'vat-popup'
}

export default VATPopup


// WEBPACK FOOTER //
// ./src/felles/Kart/popup.jsx